













































































































import { Component, Vue } from "vue-property-decorator";
import AuthService from './services/auth-service';
import { GeneralService } from "./services/general-service";
import config from './services/api-config';
import moment from 'moment';

declare var signalR;

@Component
export default class App extends Vue{
  private connection;
  private auth = new AuthService();
  private service = new GeneralService();
  
  private uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  
  created() {
    
  }

  async mounted() {
    let today = moment().format('YYYY-MM-DD');
    if (localStorage[config.sessionIdTime] !== today){
      localStorage[config.sessionIdTime] = today;
      localStorage[config.sessionId] = this.uuidv4();
      await this.service.getIP();

      const jsonSend = {
        username: this.auth.session.userName,
        sessionId: localStorage[config.sessionId],
        sessionTime: localStorage[config.sessionIdTime],
        ip: localStorage[config.currentIpAddress],
        dataTimeStamp: moment().unix(),
      };

      this.service.sendData(jsonSend).then(response => console.log(response));
    }
  }
}
